const KYB_TRADE_GATE_MESSAGES: Record<string, string> = {
  kyb_not_approved:
    "This counterparty's KYC status is not Approved — complete the Detected screening or wait for the outcome before trading.",
  kyb_effective_date_missing:
    "This counterparty's KYC effective date is missing — contact compliance before trading.",
  recycling_licence_expired:
    "This counterparty's recycling licence has expired — upload a renewed licence or file an active KYC exception before trading.",
  counterparty_soft_deleted: 'This counterparty has been deleted — restore it before trading.',
  counterparty_not_found: 'Counterparty not found — refresh the page and try again.',
};

const KYB_TRADE_GATE_FALLBACK =
  "This counterparty's KYC is not in a tradeable state — contact compliance to resolve before retrying.";

export function describeKybTradeGate(body: unknown): string | null {
  if (body === null || typeof body !== 'object') return null;
  const record = body as Record<string, unknown>;
  if (record['reason'] !== 'kyb_trade_not_ready') return null;
  const kybReason = record['kyb_reason'];
  if (typeof kybReason !== 'string') return KYB_TRADE_GATE_FALLBACK;
  return KYB_TRADE_GATE_MESSAGES[kybReason] ?? KYB_TRADE_GATE_FALLBACK;
}
